import React, { useEffect, useMemo, useRef } from 'react'
import { makeStyles } from '@mui/styles'
import { ModalBig } from '../../../base/components/modal'
import { urls } from '../../config'

export const ValidationModal = (props) => {
  const classes = useStyles(props)
  const { transaction, onSuccess } = props
  const { provideValidationRequest: { validationUri } } = transaction
  const iframeSrc = useMemo(() => `${urls.bankingApiHost}${validationUri}`, [validationUri])
  const iframeRef = useRef(null)

  const content = useMemo(() => {
    return iframeSrc
      ? <iframe className={classes.iframe} ref={iframeRef} src={iframeSrc} height="600" width="100%" />
      : null
  }, [iframeSrc])

  const handleWindowMessage = (event) => {
    if (event.data === 'StatusChanged') {
      onSuccess(transaction)
    }
  }

  useEffect(() => {
    window.addEventListener('message', handleWindowMessage, false)

    return () => {
      window.removeEventListener('message', handleWindowMessage)
    }
  })

  return (
    <ModalBig
      disableEscapeKeyDown
      disableBackdropClick
      open={true}
      classes={classes}
    >
      {content}
    </ModalBig>
  )
}

const useStyles = makeStyles(theme => ({
  content: {
    padding: 0,
    '&:first-child': {
      padding: 0,
    },
  },
  paper: {
    padding: 0,
    width: 680,
  },
  iframe: {
    border: 0,
    padding: 0,
  },
}))

export default ValidationModal
